const SET_IS_SHOWING_PODCAST_NAME_COVER_ART_ERROR_MODAL =
  'settingsScreen/SET_IS_SHOWING_PODCAST_NAME_COVER_ART_ERROR_MODAL';
export default {
  SET_IS_SHOWING_PODCAST_NAME_COVER_ART_ERROR_MODAL,
};
